define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.MFChangeStatusDomain = void 0;
    class MFChangeStatusDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: MFChangeStatusDomain.New, value: "New" },
                    { key: MFChangeStatusDomain.Unmodified, value: "Unmodified" },
                    { key: MFChangeStatusDomain.Modified, value: "Modified" },
                    { key: MFChangeStatusDomain.MarkedForDeletion, value: "Marked for Deletion" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[MFChangeStatusDomain.New] = 0;
                this.KeyIndex[MFChangeStatusDomain.Unmodified] = 1;
                this.KeyIndex[MFChangeStatusDomain.Modified] = 2;
                this.KeyIndex[MFChangeStatusDomain.MarkedForDeletion] = 3;
                this.ValueIndex = {};
                this.ValueIndex["New"] = 0;
                this.ValueIndex["Unmodified"] = 1;
                this.ValueIndex["Modified"] = 2;
                this.ValueIndex["Marked for Deletion"] = 3;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.MFChangeStatusDomain = MFChangeStatusDomain;
    Object.defineProperty(MFChangeStatusDomain, "New", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 0
    });
    Object.defineProperty(MFChangeStatusDomain, "Unmodified", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 1
    });
    Object.defineProperty(MFChangeStatusDomain, "Modified", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 2
    });
    Object.defineProperty(MFChangeStatusDomain, "MarkedForDeletion", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 3
    });
    Object.defineProperty(MFChangeStatusDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
